import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { ErrorResponseSchema } from './general'
import { PutDefaultAddressSchema, PatchUserSchema, UserSchema } from '@repo/api-types'
import { AddressSchema } from '@repo/api-types'

const c = initContract()

export const authContract = c.router({
  login: {
    method: 'POST',
    path: '/login',
    responses: {
      200: z.object({ accessToken: z.string(), refreshToken: z.string() }),
      401: ErrorResponseSchema,
    },
    body: z.object({
      email: z.string(),
      password: z.string(),
    }),
  },
  forgotPassword: {
    method: 'POST',
    path: '/forgot-password',
    responses: {
      200: z.object({ success: z.boolean() }),
      401: ErrorResponseSchema,
    },
    body: z.object({
      email: z.string(),
    }),
  },
  confirmForgotPassword: {
    method: 'POST',
    path: '/confirm-forgot-password',
    responses: {
      200: z.object({ success: z.boolean() }),
      401: ErrorResponseSchema,
    },
    body: z.object({
      email: z.string(),
      password: z.string(),
      confirmationCode: z.string(),
    }),
  },
  resetPassword: {
    method: 'POST',
    path: '/reset-password',
    responses: {
      200: z.object({ success: z.boolean() }),
      500: ErrorResponseSchema,
    },
    body: z.object({
      previousPassword: z.string(),
      password: z.string(),
    }),
  },
  updatePassword: {
    method: 'POST',
    path: '/update-password',
    responses: {
      200: z.object({ success: z.boolean() }),
      400: ErrorResponseSchema,
    },
    body: z.object({
      newPassword: z.string(),
    }),
  },
  refresh: {
    method: 'GET',
    path: '/refresh',
    responses: {
      200: z.object({ accessToken: z.string() }),
      400: ErrorResponseSchema,
    },
  },
  logout: {
    method: 'POST',
    path: '/logout',
    responses: {
      200: z.object({ success: z.boolean() }),
    },
    body: z.object({}),
  },
  getMe: {
    method: 'GET',
    path: '/me',
    responses: {
      200: UserSchema,
      400: ErrorResponseSchema,
    },
  },
  patchMe: {
    method: 'PATCH',
    path: '/me',
    body: PatchUserSchema,
    responses: {
      200: UserSchema,
      400: ErrorResponseSchema,
    },
  },

  getDefaultCustomerAddress: {
    method: 'GET',
    path: '/addresses/default',
    responses: {
      200: AddressSchema,
      400: ErrorResponseSchema,
    },
  },
  updateDefaultCustomerAddress: {
    method: 'PUT',
    path: '/addresses/default',
    body: PutDefaultAddressSchema,
    responses: {
      200: z.object({ success: z.boolean() }),
      400: ErrorResponseSchema,
    },
  },
  isEmailTaken: {
    method: 'GET',
    path: '/check-email',
    query: z.object({
      email: z.string().email(),
    }),
    responses: {
      200: z.object({ isTaken: z.boolean() }),
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
    },
  },
})
